import React from 'react';
import { useNavigate } from 'react-router-dom';
import AdminLayout from './AdminLayout';
import ChiefOfStaff from '../../components/ChiefOfStaff';

// Desktop Chief of Staff — the private line inside the admin layout (sidebar stays).
// Visibility is gated in the sidebar to the two allowlisted users, and the /cos
// endpoints enforce the same two-user allowlist server-side.
export default function AdminChiefOfStaff() {
  const navigate = useNavigate();
  return (
    <AdminLayout>
      <div style={{ height: 'calc(100vh - 150px)', maxWidth: 900, margin: '0 auto' }}>
        <ChiefOfStaff onBack={() => navigate(-1)} />
      </div>
    </AdminLayout>
  );
}
